<template>
    <div>
        <section class="totalizers-container">
            <div class="totalizers-list">
                <totalizer-block
                    :text="translate('messages.produced_volume')"
                    :number="formatTextTotalizerRow(totalizersInfo.volumeProduzido?.volumeTotalTon, 't')"
                    iconClass="lyra-icon lyra-volume"
                    :noIconTotalizer="false"
                    :detailedInformation="sortProducts(totalizersInfo.volumeProduzido?.produtos || null)"
                />
                <totalizer-block
                    :text="translate('messages.shipped_volume')"
                    :number="formatTextTotalizerRow(totalizersInfo.volumeEmbarcado?.volumeTotalTon, 't')"
                    iconClass="lyra-icon lyra-volume-vendido"
                    :noIconTotalizer="false"
                    :detailedInformation="sortProducts(totalizersInfo.volumeEmbarcado?.produtos || null)"
                />
                <totalizer-block
                    :text="translate('messages.available_volume')"
                    :number="formatTextTotalizerRow(totalizersInfo.volumeDisponivel?.volumeTotalTon, 't')"
                    iconClass="lyra-icon lyra-fabrica"
                    :noIconTotalizer="false"
                    :detailedInformation="sortProducts(totalizersInfo.volumeDisponivel?.produtos || null)"
                />
                <totalizer-block
                    :text="translate('messages.volume_available_for_export')"
                    :number="formatTextTotalizerRow(totalizersInfo.volumeParaExportacao?.volumeTotalTon, 't')"
                    iconClass="lyra-icon lyra-transfer"
                    :noIconTotalizer="false"
                    :detailedInformation="sortProducts(totalizersInfo.volumeParaExportacao?.produtos || null)"
                />
            </div>

        </section>

    </div>
</template>

<script>
import TotalizerBlock from '@/modules/warehouse/views/components/TotalizerBlock.vue';

import { mapActions, mapState, mapGetters } from 'vuex';
import formatters from '@/utils/formatters';
import { MainPageTabs } from '@/modules/warehouse/constants/MainPageTabsEnum';

export default {
    name: 'WarehouseDefault',
    components: { TotalizerBlock },
    props: {
        value: {
            type: Object,
            default: () => ({
                warehouse_id: ''
            })
        },
        filters: {
            type: Object,
            required: false,
            default: () => null
        },
        secondRowData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tabName: MainPageTabs.FACTORIES_TAB,
            hasLoaded: false,
            totalizersInfo: {},
            productOrder: {
                FARINHA: 1,
                OLEO: 2,
                CASCA: 3
            }
        };
    },
    computed: {
        ...mapState('warehouseModule', ['selectedTab', 'totalizers']),
        ...mapGetters('warehouseModule', ['getTotalizers'])
    },
    mounted() {
        if (this.selectedTab === this.tabName && !this.hasLoaded) {
            this.fetchTotalizers();
            this.hasLoaded = true;
        }
    },
    watch: {
        selectedTab: {
            handler(newVal) {
                if (this.selectedTab === this.tabName && !this.hasLoaded) {
                    this.fetchTotalizers();
                    this.hasLoaded = true;
                }
            }
        },
        totalizers: {
            handler(newVal) {
                this.totalizersInfo = this.getTotalizers;
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchTotalizers']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        formatTextTotalizerRow(data, text) {
            if (data !== 0 && (!data || data === '')) {
                return null;
            } else if (data === '-') {
                return data;
            } else {
                return formatters.minFormatNumber(data, 2, this.$i18n.locale) + (!text ? '' : (' ' + text));
            }
        },
        sortProducts(products) {
            if (!products || products.length === 0) {
                return [];
            }

            const formattedItems = products.map(({ codigo, codigoNcm, volumeTon }) => ({
                codigo: codigo,
                label: this.translate('messages.' + codigo.toLowerCase()) + ` (${codigoNcm})`,
                value: this.formatTextTotalizerRow(volumeTon, 't')
            }));
            return [...formattedItems].sort((a, b) => {
                return this.productOrder[a.codigo] - this.productOrder[b.codigo];
            });
        },
        loadTotalizers() {
            this.fetchTotalizers();
            this.hasLoaded = true;
        }
    }
};
</script>

<style scoped lang="scss">
.totalizers-container {
    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
    }

    .totalizers-list {
        width: 100%;
        display: grid;
        column-gap: 16px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
}
</style>
